////////////////////////////////////////////////////////////////////////////////////////////////////
//
// The ObjectFunc class 
// @version 0.0.2.0
// @created-date 2014.04.25
// @modified-date 2015.12.06
// @author beach.li
//
// @changes 0.0.2.0 (2015.12.06)
// Support the clone object method via the cloneObject.
// Specially, it should support the native JSON class from the browser.
//
////////////////////////////////////////////////////////////////////////////////////////////////////
//--------------------------------------------------
// construtor
//--------------------------------------------------
var tbs_util_ClassFunc = function() {
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_util_ClassFunc.prototype = {
	//--------------------------------------------------
	// static api
	//--------------------------------------------------
	/**
	 * @api
	 * It acts as the super method of the OOP.
	 * @param owner The owner/extended class.
	 * @param baseClass The base class.
	 * @param parameters The constructor parameters.
	 */
	super: function(owner, baseClass, parameters) {
		baseClass.apply(owner, parameters);
	},
	/**
	 * @api
	 * It acts as the extend method of the OOP.
	 * @param extended The extended class.
	 * @param baseClass The base class.
	 */
	extend: function(extended, baseClass) {
		var base = new baseClass;
		// use for...in and [] accessor to avoid __proto__ missed by hasOwnProperty
		for (var prop in base) {
			if (!extended[prop] && !extended.prototype[prop]) {
				extended.prototype[prop] = base[prop];
			}
		}
	},
	/**
	 * @api
	 * Get the class type.
	 * @param object The object.
	 * @TODO Need polishing for the customized object.
	 */
	getClass: function(object) {
		return Object.prototype.toString.call(object).match(/^\[object\s(.*)\]$/)[1];
	},
	/**
	 * @api
	 * Get property value according to the instance and prop.
	 * @param instance The instance.
	 * @param prop The prop name.
	 * @return The prop value.
	 */
	getPropertyOnLibrary: function(instance, prop) {
		if (instance && instance[prop]) {
			return instance[prop].call(instance);
		}
		else return null;
	},
	/**
	 * @api
	 * Set property value according to the instance and prop.
	 * @param instance The instance.
	 * @param prop The prop name.
	 * @param value The prop value.
	 */
	setPropertyOnLibrary: function(instance, prop, value) {
		if (instance && instance[prop]) {
			return instance[prop].call(instance, value);
		}
	},
	/**
	 * @api
	 * Apply the function with the instance with the given parameters.
	 * @param instance The instance.
	 * @param func The function name.
	 * @param param The parameters value.
	 * @param The function return.
	 */
	applyFunctionOnLibrary: function(instance, func, param) {
        if (this.getClass(func) == "String") {
            if (instance && instance[func]) {
                // separate the param because of ie8 issue for apply method
                // @compatible-code ie8
                if (param) {
                    return instance[func].apply(instance, param);
                }
                else return instance[func].apply(instance);
            }
        }
        else if (this.getClass(func) == "Function") {
            if (instance) {
                // separate the param because of ie8 issue for apply method
                // @compatible-code ie8
                if (param) {
                    return func.apply(instance, param);
                }
                else return func.apply(instance);
            }
            else {
                return func(param);
            }
        }
    },
};

/**
 * The static implementation approach
 * @return The static method.
 */
var instance;
if (!instance) {
	instance = new tbs_util_ClassFunc;
}

module.exports = instance;